import { render, staticRenderFns } from "./DeliveryAddressPopup.vue?vue&type=template&id=72c3c8d0&scoped=true&"
import script from "./DeliveryAddressPopup.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressPopup.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAddressPopup.vue?vue&type=style&index=0&id=72c3c8d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c3c8d0",
  null
  
)

export default component.exports